module.exports = __webpack_public_path__ + "static/media/mobile-icons-buttons-page-navigation-left-arrow-default.de13e88d.svg";